
import hasModel from '@/mixins/hasModel'
import scrollToListTop from '@/mixins/scrollToListTop'

export default {
    mixins: [hasModel, scrollToListTop],

    computed: {
        link() {
            const queryObj = { ...this.$route.query }
            queryObj[this.model.content_type.slug] = this.model.slug
            return { query: queryObj }
        },

        apiUrl() {
            return process.env.apiUrl
        },

        cardImage() {
            const image = this.model.metas.card_image || this.model.metas.banner_image
            return image ? JSON.parse(image) : this.model.cover
        },
    },
}
